<template>
    <div>
        <el-input type="textarea" :rows="5" placeholder="格式如[{'a':1,'b':2}]" v-model="thejson">
        </el-input>
        <el-button type="primary" @click="getkeys">
            提取key生成表头
        </el-button>


        <el-button type="warning" plain @click="ifremotejson=!ifremotejson">
           切换remote提取json
        </el-button>

        <jsonapi v-if="ifremotejson" @jsondone="jsondone"></jsonapi>
    </div>
  
</template>

<script>
import jsonapi from "./defineddb_json_api.vue";

export default {
    components: { jsonapi},
    data() {
        return {
            thejson: '',
            ifremotejson:false,
        }
    },
    methods: {
        jsondone(json){
            this.thejson=json
        },

        getkeys() {
            try {
                let keys = []
                let adoc = JSON.parse(this.thejson)[0]
                for (var k in adoc) {
                    keys.push(k)
                }
                this.$emit("jsonkeys", keys)
            }
            catch (e) {
                console.log("json 格式错")
            }

        }
    },
    watch: {
        thejson(newVal, oldVal) {
            this.$emit("jsondocdone", newVal)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/exceltodb/defineddb_json.vue